// Generated from the C# enums by RoushTech.Procyon.EnumExport.
// Do not edit by hand: run `npm run generate:enums` after changing a C# enum.
// A parity test in RoushTech.Procyon.Tests fails CI while this file is stale.

export enum ProjectPermission {
    ProjectAdministrator = 0,
    CanViewProject = 1,
    CanEditVersions = 2,
    CanBeAssignedTickets = 3,
    CanReassignTickets = 4,
    CanCreateTickets = 5,
    CanDeleteTickets = 6,
    CanChangeTicketStatus = 7,
    CanResolveTickets = 8,
    CanChangeTicketPriority = 9,
    CanChangeTicketType = 10,
    CanEditTicketDescription = 11,
    CanManageLabels = 12,
    CanLinkTickets = 13,
    CanSetTicketVersions = 14,
    CanUploadAttachments = 15,
    CanDeleteAttachments = 16,
    CanComment = 17,
    CanDeleteComments = 18,
    CanEditComments = 19,
    CanViewCommentHistory = 20,
    CanReportOnTickets = 21,
    CanCommentOnClosedTickets = 22,
    CanLogTime = 23,
    CanManageWorkLogs = 24,
}

export enum OrganizationPermission {
    OrganizationAdministrator = 0,
    CanViewOrganization = 1,
    CanCreateProjects = 2,
    CanManageUsers = 3,
}

export enum PortalStage {
    Open = 0,
    InProgress = 1,
    WaitingOnYou = 2,
    Resolved = 3,
    Hidden = 4,
}

export enum PortalRegistrationMode {
    Closed = 0,
    Domains = 1,
    Open = 2,
}

export enum PortalAssignmentStrategy {
    Unassigned = 0,
    RoundRobin = 1,
    LeastBusy = 2,
}

export enum TicketStatusCategory {
    ToDo = 0,
    InProgress = 1,
    Done = 2,
}

export enum TicketOrigin {
    Internal = 0,
    Portal = 1,
}

export enum TicketSearchView {
    TableView = 0,
    CompactView = 1,
}

export enum TicketStatusDeletionResult {
    Deleted = 0,
    DeleteAfterMigration = 1,
}

export enum SettingKind {
    Text = 0,
    Number = 1,
    Bytes = 2,
    Boolean = 3,
    Secret = 4,
    Date = 5,
}

export enum AuditedActions {
    All = 0,
    Insert = 1,
    Update = 2,
    Delete = 3,
}

export enum AuditLogSortBy {
    EntityType = 0,
    Date = 1,
    UserName = 2,
    Table = 3,
    Action = 4,
}

export enum TicketOrder {
    Created = 0,
    Title = 1,
    Priority = 2,
    DueDate = 3,
    Status = 4,
    Type = 5,
    Assignee = 6,
    Reporter = 7,
    Resolved = 8,
    FixVersion = 9,
    AffectVersion = 10,
    List = 11,
}

export enum SearchDirection {
    Ascending = 0,
    Descending = 1,
}

export enum UserOrder {
    DisplayName = 0,
    UserName = 1,
    Email = 2,
}

export enum UserActivityKind {
    Created = 0,
    Changed = 1,
    Commented = 2,
    Resolved = 3,
}

export enum ProjectAccessScope {
    Administrator = 0,
    Project = 1,
    AssignedProjects = 2,
    OrganizationProjects = 3,
}

export enum SubscriberTypes {
    Unknown = 0,
    User = 1,
    Project = 2,
    Organization = 3,
}

export enum RouteMode {
    Assign = 0,
    Queue = 1,
}

export enum RouteStrategy {
    RoundRobin = 0,
    LeastBusy = 1,
}

export enum ChangeLogSource {
    User = 0,
    Workflow = 1,
}

export enum AgentNoteKind {
    Note = 0,
    Decision = 1,
    Handoff = 2,
    Message = 3,
}

export enum AgentWorkState {
    Working = 0,
    NeedsYou = 1,
}
